var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-load-more" }, [
    _vm._v("\n  " + _vm._s(_vm.infoLabel) + "\n  "),
    _c(
      "button",
      {
        staticClass: "rb-load-more__button rb-btn rb-btn--black",
        attrs: { type: "button" },
        on: { click: _vm.onClick, focusin: _vm.resetFocusedTileId },
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("plp.load_more")) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }